/* JS AI Search part 2: engine data model, matching and typo repair. Loaded in order with the other js-ai-*.js files (see snippets/js-ai-search-boot.liquid).
   Overview and switches: see the header of js-ai-1-nlp.js. */
(function (root) {
  'use strict';
  var X = root.JSAIX = root.JSAIX || {};
  var POUND = X.POUND, MAX_QUERY_CHARS = X.MAX_QUERY_CHARS, cleanText = X.cleanText, tokenize = X.tokenize, stem = X.stem,
      stemTokens = X.stemTokens, osaDistance = X.osaDistance, parseBudget = X.parseBudget;
  // ------------------------------------------------------------------ engine (engine.py)
  var W_TITLE_PHRASE = 4.0, W_TITLE = 3.0, W_TYPE = 3.0, W_TYPE_HEAD = 2.0, W_TAG = 1.5, W_VENDOR = 1.5, W_UNION = 1.0;
  var SYNONYM_FACTOR = 0.85;
  var DEFAULT_K = {
    stop: ('a an the i me my we you your yours to of for in on at is are was were be been am do does did can could would should will shall may might what which who whom whose where when why how any some anything something got get gets have has had having need needs want wants wanna looking look looks show give find buy please pls plz with without and or it its that this these those there them they just like best good nice great ones things stuff sort kind type kinds options option items item products product whats ive im id youd youll under over below above than less more max maximum min minimum budget upto up pounds pound quid gbp hello hey thanks thank ok okay about around roughly approximately only also still then so if but not no yes from into out as by').split(' '),
    cheap: ['cheap', 'cheapest', 'cheaper', 'inexpensive', 'lowest', 'affordable', 'bargain', 'bargains'],
    medical: ['cure', 'cures', 'anxiety', 'pain', 'painful', 'medical', 'medicine', 'medication', 'treat', 'treatment', 'therapy', 'therapeutic', 'symptom', 'symptoms', 'depression', 'insomnia', 'prescription', 'dosage', 'health', 'healing', 'heal', 'disease', 'cancer', 'epilepsy', 'arthritis', 'nausea', 'migraine', 'ptsd', 'adhd', 'doctor', 'illness', 'sick'],
    browseExcluded: ['Gift Card', 'Freebie', 'Competition', 'Subscription', 'Drug Testing Kit']
  };

  function setOf(arr) { var o = {}; arr.forEach(function (x) { o[x] = true; }); return o; }
  function containsRun(seq, phrase) {
    var n = phrase.length;
    if (!n || n > seq.length) return false;
    for (var i = 0; i + n <= seq.length; i++) {
      var ok = true;
      for (var j = 0; j < n; j++) if (seq[i + j] !== phrase[j]) { ok = false; break; }
      if (ok) return true;
    }
    return false;
  }
  function allIn(set, alt) { for (var i = 0; i < alt.length; i++) if (!set[alt[i]]) return false; return true; }
  function r4(x) { return Math.round(x * 10000) / 10000; }
  function cmpStr(a, b) { return a < b ? -1 : a > b ? 1 : 0; }

  function makeProduct(rec) {
    var live = rec.r.filter(function (v) { return v[3]; });
    var pool = live.length ? live : rec.r;
    var prices = pool.map(function (v) { return v[2]; });
    return {
      id: String(rec.i), handle: rec.h, title: rec.t, vendor: rec.v || '', type: rec.y || '', tags: rec.g || [],
      image: rec.m || '', variants: rec.r.length, liveVariants: live,
      min: Math.min.apply(null, prices), max: Math.max.apply(null, prices), available: live.length > 0,
      recommendable: !rec.x
    };
  }

  function makeDoc(p) {
    var d = { p: p };
    d.title = stemTokens(p.title); d.titleSet = setOf(d.title);
    d.ptype = stemTokens(p.type); d.ptypeSet = setOf(d.ptype);
    d.tagSets = [];
    p.tags.forEach(function (tag) {
      if (String(tag).trim().toLowerCase() === 'az') return;
      var toks = stemTokens(tag);
      if (toks.length) d.tagSets.push(setOf(toks));
    });
    d.vendorSet = setOf(stemTokens(p.vendor));
    var all = {};
    [d.titleSet, d.ptypeSet, d.vendorSet].concat(d.tagSets).forEach(function (s) { for (var k in s) all[k] = true; });
    d.all = all;
    return d;
  }

  function altScore(doc, alt) {
    var best = 0.0;
    if (containsRun(doc.title, alt)) best = W_TITLE_PHRASE;
    else if (allIn(doc.titleSet, alt)) best = W_TITLE;
    if (allIn(doc.ptypeSet, alt)) {
      var w = W_TYPE;
      if (doc.ptype.length && alt[alt.length - 1] === doc.ptype[doc.ptype.length - 1]) w += W_TYPE_HEAD;
      best = Math.max(best, w);
    }
    for (var i = 0; i < doc.tagSets.length; i++) if (allIn(doc.tagSets[i], alt)) { best = Math.max(best, W_TAG); break; }
    if (allIn(doc.vendorSet, alt)) best = Math.max(best, W_VENDOR);
    if (best === 0.0 && allIn(doc.all, alt)) best = W_UNION;
    return best;
  }

  function Engine(data) {
    var k = data.k || {};
    this.K = {
      stop: setOf(k.stop || DEFAULT_K.stop), cheap: setOf(k.cheap || DEFAULT_K.cheap),
      medicalStems: setOf((k.medical || DEFAULT_K.medical).map(stem)),
      browseExcluded: setOf(k.browseExcluded || DEFAULT_K.browseExcluded)
    };
    this.stopStems = setOf(Object.keys(this.K.stop).map(stem));
    this.products = data.p.map(makeProduct);
    this.docs = this.products.filter(function (p) { return p.recommendable; }).map(makeDoc);
    this.byHandle = {};
    this.docs.forEach(function (d) { this.byHandle[d.p.handle] = d; this.byHandle[d.p.id] = d; }, this);
    this.generated = data.generated;
    // synonym groups
    this.groups = (data.syn || []).map(function (g) {
      var alts = [], seen = {};
      g.terms.forEach(function (term) {
        var alt = stemTokens(term);
        var key = alt.join(' ');
        if (alt.length && !seen[key]) { seen[key] = true; alts.push(alt); }
      });
      return { title: g.title, alts: alts };
    });
    this.synIndex = {}; this.synMax = 1; this.synVocab = {};
    this.groups.forEach(function (g, pos) {
      g.alts.forEach(function (alt) {
        var key = alt.join(' ');
        if (!(key in this.synIndex)) this.synIndex[key] = pos;
        this.synMax = Math.max(this.synMax, alt.length);
        alt.forEach(function (w) { this.synVocab[w] = true; }, this);
      }, this);
    }, this);
    // vocabulary for typo repair
    var freq = {};
    this.docs.forEach(function (d) { for (var t in d.all) freq[t] = (freq[t] || 0) + 1; });
    this.known = {};
    for (var t in freq) this.known[t] = true;
    for (var s in this.synVocab) this.known[s] = true;
    var cand = {};
    for (var tok in freq) if (tok.length >= 3 && /^[a-z]+$/.test(tok)) cand[tok] = freq[tok];
    for (var sv in this.synVocab) if (sv.length >= 3 && /^[a-z]+$/.test(sv) && !(sv in cand)) cand[sv] = 0;
    this.candidates = Object.keys(cand).sort().map(function (w) { return [w, cand[w]]; });
    var typeCount = {};
    this.docs.forEach(function (d) {
      var p = d.p;
      if (p.available && p.type && !this.K.browseExcluded[p.type]) typeCount[p.type] = (typeCount[p.type] || 0) + 1;
    }, this);
    this.topTypes = Object.keys(typeCount).sort(function (a, b) { return typeCount[b] - typeCount[a] || cmpStr(a.toLowerCase(), b.toLowerCase()); });
  }

  Engine.prototype._correct = function (token) {
    if (token.length < 4 || !/^[a-z]+$/.test(token) || this.known[token]) return token;
    var maxD = token.length <= 5 ? 1 : 2, best = null, sorted4 = token.length === 4 ? token.split('').sort().join('') : null;
    for (var i = 0; i < this.candidates.length; i++) {
      var cand = this.candidates[i][0], count = this.candidates[i][1];
      if (cand.charAt(0) !== token.charAt(0) || Math.abs(cand.length - token.length) > maxD) continue;
      if (sorted4 !== null && cand.split('').sort().join('') !== sorted4) continue;
      var d = osaDistance(token, cand);
      if (d > maxD) continue;
      if (best === null || d < best[0] || (d === best[0] && (-count < -best[1] || (count === best[1] && cand < best[2])))) best = [d, count, cand];
    }
    return best ? best[2] : token;
  };

  Engine.prototype._longestSyn = function (stems, start) {
    var longest = Math.min(this.synMax, stems.length - start);
    for (var len = longest; len >= 1; len--) {
      var key = stems.slice(start, start + len).join(' ');
      if (key in this.synIndex) return { length: len, group: this.groups[this.synIndex[key]] };
    }
    return null;
  };

  Engine.prototype._concepts = function (stems) {
    var concepts = [], i = 0;
    while (i < stems.length) {
      var m = this._longestSyn(stems, i);
      if (m) {
        var literal = stems.slice(i, i + m.length);
        var alts = [{ alt: literal, literal: true }], lk = literal.join(' ');
        m.group.alts.forEach(function (alt) { if (alt.join(' ') !== lk) alts.push({ alt: alt, literal: false }); });
        concepts.push({ label: literal.join(' '), alts: alts, group: m.group.title });
        i += m.length;
      } else {
        concepts.push({ label: stems[i], alts: [{ alt: [stems[i]], literal: true }], group: null });
        i += 1;
      }
    }
    var seen = {}, out = [];
    concepts.forEach(function (c) { if (!seen[c.label]) { seen[c.label] = true; out.push(c); } });
    return out;
  };

  // Ranking rule: a brand (vendor) match of the shopper's own words beats a title-only mention among equally relevant products, and "cheapest"
  // lists the brand's own products first. Mirror of _brand_hit() in prototype/jsassistant/engine.py.
  function brandHit(doc, concepts) {
    for (var i = 0; i < concepts.length; i++)
      for (var j = 0; j < concepts[i].alts.length; j++)
        if (concepts[i].alts[j].literal && allIn(doc.vendorSet, concepts[i].alts[j].alt)) return true;   // synonyms never count
    return false;
  }
  Engine.prototype._brandHit = brandHit;

  Engine.prototype._match = function (concepts) {
    var results = [];
    this.docs.forEach(function (doc) {
      var total = 0.0, matched = 0;
      concepts.forEach(function (c) {
        var best = 0.0;
        c.alts.forEach(function (a) {
          var s = altScore(doc, a.alt) * (a.literal ? 1.0 : SYNONYM_FACTOR);
          if (s > best) best = s;
        });
        if (best > 0.0) { total += best; matched += 1; }
      });
      if (matched) results.push({ doc: doc, score: total, matched: matched });
    });
    return results;
  };

  function newReply(q) {
    return { query: q, items: [], bundles: [], alternatives: [], soldOutTitles: [], budgetMin: null, budgetMax: null,
      concepts: [], corrections: [], notes: [], refusedMedical: false, excludedOutOfStock: 0, excludedOutOfRange: 0,
      unknownTerms: [], needsAi: false, kind: 'match' };
  }

  function toItem(p, kind) {
    return { id: p.id, handle: p.handle, title: p.title, type: p.type, vendor: p.vendor, image: p.image,
      priceMin: p.min, priceMax: p.max, variantCount: p.variants, variants: p.liveVariants.map(function (v) { return { id: v[0], title: v[1], price: v[2], available: true }; }),
      kind: kind };
  }

  X.setOf = setOf; X.allIn = allIn; X.r4 = r4; X.cmpStr = cmpStr; X.newReply = newReply; X.toItem = toItem; X.Engine = Engine;
})(window);